import { loadRemoteComponent } from "../microfrontends/loadRemoteModule";
import { RemoteId } from "../microfrontends/remoteRegistry";

/**
 * Warm the Sanctions Screening host adapter chunk + MF remoteEntry while the user
 * is still on Loan Details (header chip visible). Tab open then only pays for
 * roll-up / party APIs — not the remote download.
 */
let scheduled = false;

/** Isolated so tests can mock this module without loading RemoteComponent. */
export function preloadOfacScreeningHostChunk(): Promise<unknown> {
  return import(
    /* webpackChunkName: "ofac-screening-tab-container" */
    "./OfacScreeningTabContainer"
  );
}

function runPreload(): void {
  void preloadOfacScreeningHostChunk().catch(() => undefined);
  void loadRemoteComponent(RemoteId.ofacScreening).catch(() => {
    // Tab open will retry via RemoteComponent; allow another idle attempt.
    scheduled = false;
  });
}

export function preloadOfacScreening(): void {
  if (scheduled || typeof window === "undefined") return;
  scheduled = true;
  const ric = (
    window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    }
  ).requestIdleCallback;
  if (typeof ric === "function") {
    ric(() => runPreload(), { timeout: 2500 });
  } else {
    window.setTimeout(runPreload, 1);
  }
}

/** Test-only. */
export function resetOfacScreeningPreloadForTests(): void {
  scheduled = false;
}
